// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ad40150f","389":"56ab6b54","453":"8701dc61","455":"22d4e1b1","977":"bc549849"}[chunkId] + ".chunk.js";
};